webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

module.exports = {
	"new": [
		{
			"name": "Pizza bianca al prosciutto di cinghiale",
			"ingredients": "mozzarella, jambon de sanglier et poivre",
			"price": "27.-"
		}
	],
	"pizzas": [
		{
			"name": "Focaccia",
			"ingredients": "huile d’olive, ail et romarin",
			"price": "13.-"
		},
		{
			"name": "Calzone nutella",
			"ingredients": "nutella (pour deux personnes)",
			"price": "14.-"
		},
		{
			"name": "Margherita",
			"ingredients": "sauce tomate et mozzarella",
			"price": "17.-"
		},
		{
			"name": "Prosciutto",
			"ingredients": "sauce tomate, mozzarella et jambon",
			"price": "19.-"
		},
		{
			"name": "Napoli",
			"ingredients": "sauce tomate, mozzarella, câpres, anchois et olives",
			"price": "20.-"
		},
		{
			"name": "Leccese",
			"ingredients": "sauce tomate, mozzarella, lard, câpres et oignons",
			"price": "20.-"
		},
		{
			"name": "Hawaii",
			"ingredients": "sauce tomate, mozzarella, jambon et ananas",
			"price": "20.-"
		},
		{
			"name": "Merguez",
			"ingredients": "sauce tomate, mozzarella, merguez",
			"price": "20.50"
		},
		{
			"name": "Calzone",
			"ingredients": "sauce tomate, mozzarella, jambon et oeuf",
			"price": "21.-"
		},
		{
			"name": "Parigi",
			"ingredients": "sauce tomate, mozzarella, jambon et champignons de Paris",
			"price": "21.-"
		},
		{
			"name": "Diavola",
			"ingredients": "sauce tomate, mozzarella, salami piquant",
			"price": "21.-"
		},
		{
			"name": "Cacciatora",
			"ingredients": "sauce tomate, mozzarella, lard et chanterelles",
			"price": "21.-"
		},
		{
			"name": "Ai gamberetti",
			"ingredients": "sauce tomate, mozzarella, crevettes, ail et basilic",
			"price": "21.-"
		},
		{
			"name": "Romana",
			"ingredients": "sauce tomate, mozzarella, jambon, champignons et oeuf",
			"price": "21.50"
		},
		{
			"name": "Paesana",
			"ingredients": "sauce tomate, mozzarella, merguez, poivrons et oignons",
			"price": "22.-"
		},
		{
			"name": "Tunisina",
			"ingredients": "sauce tomate, mozzarella, merguez et salami piquant",
			"price": "22.-"
		},
		{
			"name": "4 Formaggi",
			"ingredients": "sauce tomate, mozzarella, gruyère, gorgonzola et pecorino",
			"price": "22.-"
		},
		{
			"name": "Tonella",
			"ingredients": "sauce tomate, mozzarella, thon, oeuf et oignons",
			"price": "22.-"
		},
		{
			"name": "Indiana",
			"ingredients": "sauce tomate, mozzarella, poulet et sauce au curry",
			"price": "22.-"
		},
		{
			"name": "Capricciosa",
			"ingredients": "sauce tomate, mozzarella, jambon, salami piquant, olives et poivrons",
			"price": "22.50"
		},
		{
			"name": "4 Stagioni",
			"ingredients": "sauce tomate, mozzarella, jambon, poivrons, artichauts et champignons",
			"price": "23.-"
		},
		{
			"name": "Caprese",
			"ingredients": "sauce tomate, mozzarella, mozzarella di bufala, petites tomates et basilic",
			"price": "23.-"
		},
		{
			"name": "Carciofara",
			"ingredients": "mozzarella, pecorino, artichauts frais et petites tomates",
			"price": "23.-"
		},
		{
			"name": "Forestiera",
			"ingredients": "sauce tomate, mozzarella, mélange de champignons frais",
			"price": "23.-"
		},
		{
			"name": "Vegetariana",
			"ingredients": "sauce tomate, mozzarella, aubergines, courgettes, olives et poivrons rôtis",
			"price": "23.-"
		},
		{
			"name": "Alla Pizzetta",
			"ingredients": "sauce tomate, mozzarella, jambon, salami piquant, merguez, champignons, poivrons et olives",
			"price": "24.-"
		},
		{
			"name": "Ai gamberi",
			"ingredients": "sauce tomate, mozzarella, gambas (crevette géante), ail et basilic",
			"price": "24.-"
		},
		{
			"name": "Contadina",
			"ingredients": "sauce tomate, provola fumée, saucisse maison, épinards et oignons rouges",
			"price": "24.-"
		},
		{
			"name": "Grand-Rue",
			"ingredients": "sauce tomate, mozzarella, viande de veau, champignons et café de Paris",
			"price": "24.-"
		},
		{
			"name": "Parma",
			"ingredients": "sauce tomate, mozzarella et jambon de Parme",
			"price": "24.-"
		},
		{
			"name": "Talenzana",
			"ingredients": "crème, mozzarella, taleggio, aubergines et tomates fraîches",
			"price": "24.-"
		},
		{
			"name": "Ai frutti di mare",
			"ingredients": "sauce tomate, mozzarella, calamars, moules, vongoles, crevettes, poulpe et ail",
			"price": "25.-"
		},
		{
			"name": "Balsamica",
			"ingredients": "sauce tomate, mozzarella, rucola, mozzarella di bufala et crème de balsamique",
			"price": "25.-"
		},
		{
			"name": "Valtellinese",
			"ingredients": "sauce tomate, mozzarella, taleggio et bresaola",
			"price": "25.-"
		},
		{
			"name": "Blanche au saumon fumé",
			"ingredients": "mozzarella, ricotta et saumon fumé du fumoir de Chailly",
			"price": "27.-"
		},
		{
			"name": "I mortacci",
			"ingredients": "crème, mozzarella, mortadella IGP, burrata et crème de pistaches de Bronte DOP",
			"price": "27.-"
		},
		{
			"name": "Primavera",
			"ingredients": "sauce tomate, mozzarella, jambon de Parme, rucola, écailles de parmesan et petites tomates",
			"price": "27.-"
		},
		{
			"name": "Andria",
			"ingredients": "sauce tomate, mozzarella, bresaola, burrata, rucola et olives taggiasche",
			"price": "28.-"
		}
	],
	"bruschette": [
		{
			"name": "Bruschetta ai pomodori",
			"ingredients": "tranches de pain avec tomates, ail, basilic et huile d’olive",
			"price": "13.-"
		},
		{
			"name": "Bruschetta verde",
			"ingredients": "tranches de pain avec cornichons, ail, câpres et anchois",
			"price": "13.-"
		}
	],
	"pates": [
		{
			"name": "Napoli",
			"ingredients": "sauce tomate, ail et basilic",
			"price": "20.-"
		},
		{
			"name": "Aglio, olio e peperoncino",
			"ingredients": "ail, huile d’olive et piments",
			"price": "20.-"
		},
		{
			"name": "Al tonno",
			"ingredients": "sauce tomate, thon, oignons et basilic",
			"price": "21.-"
		},
		{
			"name": "Ai carciofi",
			"ingredients": "artichauts frais, tomates fraîches et écailles de parmesan",
			"price": "21.-"
		},
		{
			"name": "All’amatriciana",
			"ingredients": "sauce tomate, lard et oignons",
			"price": "21.-"
		},
		{
			"name": "All’arrabbiata",
			"ingredients": "sauce tomate, olives, piments, ail et persil",
			"price": "21.-"
		},
		{
			"name": "Al gorgonzola",
			"ingredients": "sauce tomate, crème et gorgonzola",
			"price": "21.-"
		},
		{
			"name": "Bolognese",
			"ingredients": "sauce tomate et viande de boeuf",
			"price": "22.-"
		},
		{
			"name": "Ai porcini",
			"ingredients": "crème, jambon et bolets",
			"price": "22.-"
		},
		{
			"name": "Alle melanzane",
			"ingredients": "sauce tomate, aubergines, mozzarella di bufala et basilic",
			"price": "22.-"
		},
		{
			"name": "Diavola",
			"ingredients": "sauce tomate, salami piquant, ail et piments",
			"price": "22.-"
		},
		{
			"name": "Prosciutto e zafferano",
			"ingredients": "crème, jambon et safran",
			"price": "22.-"
		},
		{
			"name": "Puttanesca",
			"ingredients": "sauce tomate, câpres, anchois, olives, ail et piments",
			"price": "22.-"
		},
		{
			"name": "Carbonara",
			"ingredients": "crème, lard et oeuf",
			"price": "22.-"
		},
		{
			"name": "Al pollo",
			"ingredients": "crème, poulet et sauce tomate",
			"price": "23.-"
		},
		{
			"name": "Alle spugnole",
			"ingredients": "crème et morilles",
			"price": "25.-"
		},
		{
			"name": "Linguine alle vongole veraci *",
			"ingredients": "Vongole veraci, tomates fraîches, ail, piment et persil (* selon arrivage)",
			"price": "25.-"
		},
		{
			"name": "Al salmone affumicato",
			"ingredients": "sauce tomate, crème et saumon fumé du fumoir de Chailly",
			"price": "26.-"
		},
		{
			"name": "Ai frutti di mare",
			"ingredients": "sauce tomate, calamars, moules, vongoles, crevettes et poulpe",
			"price": "27.-"
		}
	],
	"patesmaison": [
		{
			"name": "Cannelloni ricotta e spinaci",
			"ingredients": "sauce tomate, ricotta, épinards et fromage râpé",
			"price": "21.-"
		},
		{
			"name": "Gnocchi",
			"ingredients": "sauce tomate, mozzarella di bufala et basilic",
			"price": "22.-"
		},
		{
			"name": "Cannelloni di carne",
			"ingredients": "sauce tomate, viande de veau et fromage râpé",
			"price": "23.-"
		}
	],
	"risottos": [
		{
			"name": "Alla Milanese",
			"ingredients": "safran et fromage râpé",
			"price": "24.-"
		},
		{
			"name": "Ai carciofi",
			"ingredients": "artichauts frais et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Ai porcini",
			"ingredients": "bolets et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Al prosecco",
			"ingredients": "vin prosecco et fromage râpé",
			"price": "26.-"
		},
		{
			"name": "Ai gamberi",
			"ingredients": "gambas, roquette, petites tomates et fromage râpé",
			"price": "28.-"
		}
	],
	"salades": [
		{
			"name": "Insalata mista",
			"ingredients": "laitue iceberg, carottes, céleri-pomme, petites tomates et oignons ",
			"hprice": "7.-",
			"price": "10.-"
		},
		{
			"name": "Insalata Caprese",
			"ingredients": "tomates, mozzarella di bufala et basilic",
			"hprice": "10.-",
			"price": "17.-"
		},
		{
			"name": "Insalata di rucola",
			"ingredients": "roquette, petites tomates, écailles de parmesan et oignons",
			"hprice": "10.-",
			"price": "17.-"
		},
		{
			"name": "Insalata di pollo",
			"ingredients": "laitue iceberg, poulet, maïs, poivrons rôtis et oignons",
			"hprice": "11.-",
			"price": "18.-"
		}
	],
	"desserts": [
		{
			"name": "Tiramisù fait maison",
			"price": "8.-"
		},
		{
			"name": "Panna cotta fait maison",
			"price": "6.-"
		},
		{
			"name": "Flan caramel fait maison",
			"price": "6.-"
		},
		{
			"name": "Boule de glace (Vanille / Fiordilatte / Stracciatella / Pistache / Noisette)",
			"price": "4.-"
		}
	],
	"boissons": {
		"dl": [
			{
				"name": "Valser Classic / Silence / Limelite",
				"price": "3.-"
			},
			{
				"name": "FuseTea Lemon / Peach / Green tea",
				"price": "3.50"
			},
			{
				"name": "Coca-Cola / Zero",
				"price": "3.50"
			},
			{
				"name": "Fanta / Mango",
				"price": "3.50"
			},
			{
				"name": "Sprite",
				"price": "3.50"
			}
		],
		"cl": [
			{
				"name": "Sanpellegrino Limonata / Aranciata / Aranciata amara / Chinotto",
				"price": "3.50"
			}
		],
		"l": [
			{
				"name": "Valser Classic / Silence",
				"price": "5.-"
			},
			{
				"name": "Coca-Cola",
				"price": "6.-"
			},
			{
				"name": "FuseTea Peach",
				"price": "6.-"
			}
		]
	}
};

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Main___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Main__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Menu__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Menu__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Accueil',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Main___default.a
  }, {
    path: '/menu',
    name: 'Carte des mets',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Menu___default.a
  }]
}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(5),
  /* template */
  __webpack_require__(16),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_timetable_json__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_timetable_json__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      timeData: __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default.a,
      todayTime: __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default.a.special.from < new Date().getTime() && __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default.a.special.to > new Date().getTime() ? __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default.a.special.time : __WEBPACK_IMPORTED_MODULE_0__data_timetable_json___default.a.opening[new Date().getDay()].time
    };
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_menu_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_menu_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_menu_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_daydish_json__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_daydish_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__data_daydish_json__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'main',
  data: function data() {
    return {
      dayDish: __WEBPACK_IMPORTED_MODULE_1__data_daydish_json___default.a,
      menuData: __WEBPACK_IMPORTED_MODULE_0__data_menu_json___default.a,
      randMenu: __WEBPACK_IMPORTED_MODULE_0__data_menu_json___default.a.pizzas.slice().sort(function () {
        return 0.5 - Math.random();
      }).splice(0, 3).sort(function (a, b) {
        return a.price > b.price;
      }),
      isMobile: function isMobile(a) {
        return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
        );
      }
    };
  },

  mounted: function mounted() {
    if (!this.isMobile()) {
      $('.parallax-window').each(function () {
        $(this).parallax($.extend(true, {
          lazyLoad: true,
          mode: 'parallax',
          speedFactor: 0.3
        }, $(this).data()));
      });
    }

    if ($(window).scrollTop() > 100) {
      $('html,body').animate({ scrollTop: 0 }, 1500, 'easeInOutQuad');
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_menu_json__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_menu_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__data_menu_json__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'menu',
  data: function data() {
    return {
      menuData: __WEBPACK_IMPORTED_MODULE_0__data_menu_json___default.a,
      isMobile: function isMobile(a) {
        return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())
        );
      }
    };
  },

  mounted: function mounted() {
    if (!this.isMobile()) {
      $('.parallax-window').each(function () {
        $(this).parallax($.extend(true, {
          lazyLoad: true,
          mode: 'parallax',
          speedFactor: 0.3
        }, $(this).data()));
      });
    }

    if ($(window).scrollTop() > 100) {
      $('html,body').animate({ scrollTop: 0 }, 1500, 'easeInOutQuad');
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(3);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = true;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(9)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(14),
  /* scopeId */
  "data-v-205da860",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(10)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(15),
  /* scopeId */
  "data-v-67560f14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "daydish"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "offer-left"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v(_vm._s(_vm.dayDish.date))]), _vm._v(" "), _c('h2', {
    staticClass: "section-title"
  }, [_vm._v(_vm._s(_vm.dayDish.title))]), _vm._v(" "), _vm._l((_vm.dayDish.menu), function(dish, index) {
    return _c('div', {
      staticClass: "offer-item daydish"
    }, [_c('div', [_c('p', [_vm._v(_vm._s(dish.day))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(dish.dish))])])])
  })], 2), _vm._v(" "), _c('p', {
    staticClass: "daydish info"
  }, [_vm._v("* " + _vm._s(_vm.dayDish.info))])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), (!_vm.isMobile()) ? _c('section', {
    staticClass: "parallax-window",
    attrs: {
      "id": "deco",
      "data-background": "static/img/bg/outdor.jpg"
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 hidden-sm hidden-xs"
  }, [_c('div', {
    staticClass: "offer-right"
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/img/bg/meals.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/menu"
    }
  }, [_vm._v("\n              Nos mets\n              "), _c('span', [_vm._v("à emporter")])]), _vm._v(" "), _c('a', {
    staticClass: "uber",
    attrs: {
      "href": "https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ",
      "target": "_blank"
    }
  })])])
}]}

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu"
  }, [_c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "new"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Actuellement")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.new), function(newPlate, index) {
    return (index < Math.ceil(_vm.menuData.new.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(newPlate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(newPlate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(newPlate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.new), function(newPlate, index) {
    return (index >= _vm.menuData.new.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(newPlate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(newPlate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(newPlate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "pizza"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pizzas")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pizzas), function(pizza, index) {
    return (index < Math.ceil(_vm.menuData.pizzas.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pizza.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pizza.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pizza.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pizzas), function(pizza, index) {
    return (index >= _vm.menuData.pizzas.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pizza.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pizza.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pizza.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "bruschette"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Bruschette")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.bruschette), function(bruschetta, index) {
    return (index < Math.ceil(_vm.menuData.bruschette.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(bruschetta.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bruschetta.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(bruschetta.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.bruschette), function(bruschetta, index) {
    return (index >= _vm.menuData.bruschette.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(bruschetta.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(bruschetta.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(bruschetta.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "pasta"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pâtes")]), _vm._v(" "), _c('span', {
    staticClass: "section-suptitle text-center"
  }, [_vm._v("Spaghetti • Penne • Rigatoni • Orecchiette • Tagliatelle")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pates), function(pate, index) {
    return (index < Math.ceil(_vm.menuData.pates.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.pates), function(pate, index) {
    return (index >= _vm.menuData.pates.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "home-pasta"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Pâtes maison")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.patesmaison), function(pate, index) {
    return (index < Math.ceil(_vm.menuData.patesmaison.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.patesmaison), function(pate, index) {
    return (index >= _vm.menuData.patesmaison.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(pate.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(pate.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(pate.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "risotto"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Risottos")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.risottos), function(risotto, index) {
    return (index < Math.ceil(_vm.menuData.risottos.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(risotto.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(risotto.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(risotto.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.risottos), function(risotto, index) {
    return (index >= _vm.menuData.risottos.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(risotto.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(risotto.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(risotto.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('section', {
    staticClass: "padd-100 dark-bg",
    attrs: {
      "id": "salad"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Salades")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(5), _vm._v(" "), _vm._l((_vm.menuData.salades), function(salade, index) {
    return (index < Math.ceil(_vm.menuData.salades.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(salade.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(salade.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(salade.price))]), _vm._v(" "), _c('span', {
      staticClass: "offer-hprice"
    }, [_vm._v(_vm._s(salade.hprice))])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(6), _vm._v(" "), _vm._l((_vm.menuData.salades), function(salade, index) {
    return (index >= _vm.menuData.salades.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(salade.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(salade.ingredients))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(salade.price))]), _vm._v(" "), _c('span', {
      staticClass: "offer-hprice"
    }, [_vm._v(_vm._s(salade.hprice))])]) : _vm._e()
  })], 2)])])])])]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "desserts"
    }
  }, [_c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("Desserts")]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "menu-item"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.desserts), function(dessert, index) {
    return (index < Math.ceil(_vm.menuData.desserts.length / 2)) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(dessert.name))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(dessert.price))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, _vm._l((_vm.menuData.desserts), function(dessert, index) {
    return (index >= _vm.menuData.desserts.length / 2) ? _c('div', {
      staticClass: "offer-item"
    }, [_c('div', [_c('h3', [_vm._v(_vm._s(dessert.name))])]), _vm._v(" "), _c('span', {
      staticClass: "offer-price"
    }, [_vm._v(_vm._s(dessert.price))])]) : _vm._e()
  }))])])])])]), _vm._v(" "), (!_vm.isMobile()) ? _c('section', {
    staticClass: "parallax-window",
    attrs: {
      "id": "deco",
      "data-background": "static/img/bg/dessert.jpg"
    }
  }) : _vm._e(), _vm._v(" "), _c('section', {
    staticClass: "padd-100",
    attrs: {
      "id": "drink"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Bouteilles 5dl\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.dl), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Canettes 33cl\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.cl), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('span', {
    staticClass: "section-suptitle"
  }, [_vm._v("Boissons")]), _vm._v(" "), _c('h4', {
    staticClass: "section-title"
  }, [_vm._v("\n            Bouteilles 1l\n          ")]), _vm._v(" "), _vm._l((_vm.menuData.boissons.l), function(boisson, index) {
    return _c('div', {
      staticClass: "drink-item"
    }, [_c('span', [_vm._v(_vm._s(boisson.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(boisson.price))])])
  })], 2)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer-item"
  }, [_c('div', [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "offer-price"
  }, [_c('i', {
    staticClass: "fa fa-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "offer-hprice"
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offer-item second"
  }, [_c('div', [_c('h3', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")])]), _vm._v(" "), _c('span', {
    staticClass: "offer-price"
  }, [_c('i', {
    staticClass: "fa fa-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "offer-hprice"
  }, [_c('i', {
    staticClass: "fa fa-adjust",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "submenu"
    }
  }, [_c('div', [_c('ul', [_c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pizza').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pizzas")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#bruschette').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Bruschette")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#pasta').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Pâtes")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#risotto').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Risottos")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#salad').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("Salades")])])])])])
}]}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "site-wrapper"
    }
  }, [_c('header', {
    attrs: {
      "id": "site-header"
    }
  }, [_c('div', {
    staticClass: "nav-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', [(_vm.timeData.special.from == 0 || _vm.timeData.special.from >= (Date.now() / 1000 | 0) || _vm.timeData.special.to <= (Date.now() / 1000 | 0)) ? _c('li', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("Aujourd'hui: " + _vm._s(_vm.todayTime))]) : _vm._e(), _vm._v(" "), (_vm.timeData.special.from != 0 && _vm.timeData.special.from < (Date.now() / 1000 | 0) && _vm.timeData.special.to > (Date.now() / 1000 | 0)) ? _c('li', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v("Aujourd'hui: " + _vm._s(_vm.timeData.special.time))]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "navbar",
    attrs: {
      "role": "navigation"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "sr-only"
  }, [_vm._v("La Pizzetta")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-collapse collapse"
  }, [_c('li', [_c('a', {
    class: {
      active: _vm.$route.name == 'Accueil'
    },
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("accueil")])]), _vm._v(" "), _c('li', [_c('a', {
    class: {
      active: _vm.$route.name == 'Carte des mets'
    },
    attrs: {
      "href": "#/menu"
    }
  }, [_vm._v("carte des mets")])]), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "parallax-window",
    class: {
      reduced: _vm.$route.name == 'Carte des mets'
    },
    attrs: {
      "id": "main-slider",
      "data-background": "static/img/bg/pizza.jpg"
    }
  }, [(_vm.$route.name == 'Accueil') ? _c('div', [_vm._m(7), _vm._v(" "), _c('span', {
    staticClass: "scoll-down"
  }, [_vm._v("Défiler vers le bas")])]) : _vm._e(), _vm._v(" "), (_vm.$route.name != 'Accueil') ? _c('div', [_c('h1', {
    staticClass: "section-title white-font text-center"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('ul', [_vm._m(8), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$route.name))])])]) : _vm._e()]), _vm._v(" "), _c('router-view'), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "site-footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "open-hours"
  }, [(_vm.timeData.special.from != 0) ? _c('div', [_c('span', {
    staticClass: "foot-title"
  }, [_vm._v(_vm._s(_vm.timeData.special.name))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.timeData.special.digest))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.timeData.special.time))])]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "foot-title"
  }, [_vm._v("Horaires d'ouverture")]), _vm._v(" "), _c('table', _vm._l((_vm.timeData.compact), function(time) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(time.days))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(time.time))])])
  }))])])])]), _vm._v(" "), _vm._m(11)])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-loader"
  }, [_c('div', {
    staticClass: "loading"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v("021 944 04 03")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "social-bloc"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/lapizzetta.ch/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "index.html",
      "title": "La Pizzetta"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-flat.svg",
      "alt": "",
      "width": "170"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "menu-mobile visible-xs",
    attrs: {
      "data-target": ".navbar-collapse",
      "data-toggle": "collapse",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "onclick": "$('html,body').animate({scrollTop: $('#contact').offset().top},1500,'easeInOutQuad');"
    }
  }, [_vm._v("contact")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "uber"
  }, [_c('a', {
    attrs: {
      "href": "https://www.ubereats.com/ch/store/la-pizzetta/Snc5SHZ5SJ2AUr5MTHHiKQ",
      "target": "_blank"
    }
  }, [_vm._v("Livraison  "), _c('img', {
    attrs: {
      "src": "static/img/ubereats.svg",
      "height": "10px",
      "alt": "Uber Eats"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-slogan"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo.svg",
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#/"
    }
  }, [_vm._v("Accueil")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "contact"
    }
  }, [_c('div', {
    attrs: {
      "id": "maps"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8 col-md-4"
  }, [_c('div', {
    staticClass: "ctc-item"
  }, [_c('span', {
    staticClass: "section-suptitle text-center"
  }, [_vm._v("\n\t\t\t\t\t\t\t\tContact\n\t\t\t\t\t\t\t")]), _vm._v(" "), _c('h2', {
    staticClass: "section-title sep-type-2 text-center"
  }, [_vm._v("\n                    Commandez vos mets\n                  ")]), _vm._v(" "), _c('p', {
    staticClass: "tel"
  }, [_vm._v("021 944 04 03")]), _vm._v(" "), _c('div', {
    staticClass: "widget"
  }, [_c('b', [_vm._v("Adresse")]), _vm._v(" "), _c('p', [_vm._v("\n                      La Pizzetta"), _c('br'), _vm._v("\n                      Grand-Rue 5"), _c('br'), _vm._v("\n                      1814 La Tour-de-Peilz\n                    ")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "bloc-cms"
  }, [_c('img', {
    attrs: {
      "src": "static/img/logo-flat.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                    La pizza traditionnelle à longue maturation,"), _c('br'), _vm._v("\n                    à emporter chez vous."), _c('br'), _vm._v("\n                    Possibilité, aussi, de la déguster sur place.\n                  ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-end"
  }, [_c('div', {
    staticClass: "social"
  }, [_c('ul', [_c('li', {
    staticClass: "social-bloc"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://www.facebook.com/lapizzetta.ch/"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://fr.tripadvisor.ch/Restaurant_Review-g1130892-d12355409-Reviews-La_Pizzetta-La_Tour_de_Peilz_Canton_of_Vaud.html"
    }
  }, [_c('i', {
    staticClass: "fa fa-tripadvisor"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("Revenir en haut")])])])
}]}

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, exports) {

module.exports = {
	"date": "du 14.01 au 17.01.2025",
	"title": "Assiette du jour à 18.-",
	"info": "Toutes les assiettes sont accompagnées d'une petite salade",
	"menu": [
		{
			"day": "Au choix:",
			"dish": "Rigatoni Carbonara"
		},
		{
			"day": "--",
			"dish": "Spaghetti Bolognaise"
		},
		{
			"day": "--",
			"dish": "Tagliatelle aux crevettes"
		},
		{
			"day": "--",
			"dish": "Risotto aux bolets"
		}
	]
};

/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = {
	"opening": [
		{
			"day": "Di",
			"time": "17:30 - 21:30"
		},
		{
			"day": "Lu",
			"time": "Fermé"
		},
		{
			"day": "Ma",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Me",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Je",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Ve",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"day": "Sa",
			"time": "17:30 - 21:30"
		}
	],
	"compact": [
		{
			"days": "Lu",
			"time": "Fermé"
		},
		{
			"days": "Ma - Je",
			"time": "11:30 - 14:00 / 17:30 - 21:30"
		},
		{
			"days": "Ve - Sa",
			"time": "11:30 - 14:00 / 17:30 - 21.30"
		},
		{
			"days": "Di",
			"time": "17:30 - 21:30"
		}
	],
	"special": {
		"from": 0,
		"to": 0,
		"digest": "",
		"name": "",
		"time": ""
	}
};

/***/ })
],[8]);


// WEBPACK FOOTER //
// static/js/app.84fedc4023b799e2f0e2.js